/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 19-08-2026
 *
 * De toastmelding rechtsonder in het canvas (golf 3e). Vervangt `#apitoast` in canvas.html.
 * Leest de `ToastService`, die de melding en zijn levensduur beheert.
 */
import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {BaseIslandComponent} from '../base-island.component';
import {ToastService} from '../../services/toast.service';

@Component({
    selector: 'dl-toast',
    standalone: true,
    templateUrl: './dl-toast.component.html',
    styleUrls: ['./dl-toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
    host: {
        '[class.dl-toast--zichtbaar]': 'toastService.toast()',
        '[attr.data-soort]': 'soort()'
    }
})
export class DlToastComponent extends BaseIslandComponent {

    /**
     * De bron van de melding.
     */
    protected readonly toastService = inject(ToastService);

    /**
     * De soort melding (bijvoorbeeld `error` of `waarschuwing`), als attribuut op de host. Een melding
     * met een soort krijgt de feedbackkleur; zonder soort is het een gewone mededeling.
     */
    protected readonly soort = computed(() => this.toastService.toast()?.soort ?? null);

    constructor() { super(); }
}
